function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
const hardcodedItineraryInfo = {
  refundableFareUpgrade: false,
  refundableFareUpgradePrice: undefined,
  refundableFareUpgradeShown: false,
  externalSelectionRequest: undefined
};
export const createItinerarySelectionIntegration = ({
  AB,
  trigger,
  setSessionStorageKey
}) => {
  let bookedItinerary;
  const setRequiredDataInSessionStorage = info => {
    Object.entries(info).forEach(([key, value]) => {
      setSessionStorageKey(key, value);
    });
  };
  const setCreateShoppingCartData = data => trigger('frontend-shell:setCreateShoppingCartData', {
    data,
    typeOfCart: 'preShoppingCart'
  });
  const goToNextPage = data => {
    const flightSelectionData = {
      data: _objectSpread(_objectSpread({}, data), hardcodedItineraryInfo),
      flightNumbers: data.flightNumbers
    };
    if (AB.isFecoCheckoutPassengers) {
      trigger('frontend-shell:showWaitingBetweenSearchAndPax', flightSelectionData);
    } else {
      trigger('frontend-shell:bookFlight', flightSelectionData);
    }
  };
  const selectItinerary = ({
    info,
    request
  }) => {
    bookedItinerary = request;
    setRequiredDataInSessionStorage(info);
    setCreateShoppingCartData(request);
  };
  const continueToPassengers = () => goToNextPage(bookedItinerary);
  const selectItineraryAndContinueToPassengers = ({
    info,
    request
  }) => {
    setRequiredDataInSessionStorage(info);
    goToNextPage(request);
  };
  const continueWithHotel = () => goToNextPage(_objectSpread(_objectSpread({}, bookedItinerary), {}, {
    upsellTouchpointClicked: true
  }));
  const recoverSearchRequest = searchRequest => trigger('frontend-shell:change-search-request', searchRequest);
  const prepareShoppingCart = ({
    request
  }) => trigger('frontend-shell:precreateShoppingCart', {
    data: request,
    typeOfCart: 'preShoppingCart'
  });
  return {
    selectItinerary,
    continueToPassengers,
    continueWithHotel,
    selectItineraryAndContinueToPassengers,
    recoverSearchRequest,
    prepareShoppingCart
  };
};